<template>
  <div class="container orderInfo" :data-corp-id="corpId"> 
        <div v-if="orderDetail.shippingType==2&&orderDetail.welfareType==1">
          <div class="self_des">
            <p class="title">自提说明</p>
            <p class="tips">{{orderDetail.shippingNote}}</p>
          </div>
          <div class="product_item">
            <p class="title">福利信息</p>
            <div class="item_wrap">
              <div class="img_box">
               <img :src="orderDetail.originalImg" alt="">
               </div>
              <dl>
                <dt>{{orderDetail.goodsName}}</dt>
                <dd>{{orderDetail.catName}}</dd>
                <dd>数量：{{orderDetail.totalCount}}</dd>
              </dl>
            </div>
          </div>
         <!--  <div class="btn-wrap">
            <a href="javascript:;" class="btn btn-default">确认领取</a>
          </div> -->
        </div>
        <div v-if="orderDetail.welfareType==2&&orderDetail.isVirtual==1">
          <div class="product_item">
            <p class="title">福利信息</p>
            <div class="item_wrap" @click.stop="goToWelfareDetail(orderDetail)">
                <div class="img_box">
                 <img :src="orderDetail.originalImg" alt="">
                 </div>
                <dl>
                  <dt>{{orderDetail.goodsName}}</dt>
                  <dd>{{orderDetail.catName}}</dd>
                    <dd>数量：{{orderDetail.totalCount}}<span v-if="orderDetail.extensionVirtualCode=='no_require_mobile'" class="status">状态：{{orderDetail.outerStatusText||'确认中...'}}</span></dd>
                </dl>
              </div>
              <template  v-if="orderDetail.extensionVirtualCode=='no_require_mobile'">
                  <dl class="virtual no_require_mobile_msg" v-if="orderDetail.outerStatusText!='已派发'">
                    <dd>派发有延迟，请耐心等待</dd>
                    <dd>请一小时后由『我的福利』进入此处查看结果</dd>
                </dl> 
              </template>
              <dl class="virtual" v-else>
                <dt>卡密：</dt>
                <span>
                  <input v-if="orderDetail.goodsContent&&orderDetail.goodsContent!=''" class="clip-board" type="text" name="cdkey" v-model="orderDetail.goodsContent" @focus="focus($event)"/>
                  <input v-else type="text" v-model="cdkeyText" readonly class="readonlyinput" />
                  <!-- <input class="clip-board" type="text" name="cdkey" v-model="orderDetail.goodsContent" readonly="readonly" @focus="focus($event)"/> -->
                  <button v-if="orderDetail.goodsContent&&orderDetail.goodsContent!=''" class="button" v-bind:data-clipboard-text="orderDetail.goodsContent" >复制</button>
                  <button v-else class="button" @click="getcdkey" :disabled="getcdkeyDis">提取</button>
                </span>
                <a href="/m/#/help/5" class="hp" v-if="orderDetail.goodsType==1">使用指南</a>
                <dd v-if="orderDetail.goodsContent&&orderDetail.goodsContent!=''">已发送至 {{orderDetail.mobile}}</dd>
                <dd v-else>为确保安全，卡密需手工提取</dd>
                <dd>请注意保密，被坏宝宝抢去了，关怀君也打不过哦</dd>
                <div id="m-toast-pop" class="m-toast-pop" v-if="copyState">
                  <div class="m-toast-inner">
                    <div class="m-toast-inner-text" id="m-toast-inner-text">{{toastMsg}}</div>
                  </div>
                </div>
              </dl> 
          </div>
          
        </div>
      <div  v-if="(orderDetail.isVirtual==0&&orderDetail.welfareType==2)||(orderDetail.shippingType==1&&orderDetail.welfareType==1)">
        <div class="product_item" @click.stop="goToWelfareDetail(orderDetail)">
          <p class="title">福利商品<span class="state" v-if="statusText">{{statusText}}</span></p>
          <div class="item_wrap">
              <div class="img_box">
               <img :src="orderDetail.originalImg" alt="">
               </div>
              <dl>
                <dt>{{orderDetail.goodsName}}</dt>
                <dd>{{orderDetail.catName}}</dd>
                <dd>数量：{{orderDetail.totalCount}}</dd>
              </dl>
            </div>
        </div>
        <div class="track_info" v-if="orderDetail.shippingStatus==1">
          <p class="title">物流状态</p>
          <div class="track_wrap" @click="goExpress(orderDetail)">
               <dl>
                 <dt v-if="orderDetail.shippingResultVo">
                  <span class="con">{{orderDetail.shippingResultVo.context}}</span>
                  <span class="icon"> <i class="arrow_right"></i></span>
                 </dt>
                 <dt v-else>
                  <span class="con">查看物流详情</span>
                  <span class="icon"> <i class="arrow_right"></i></span>
                </dt>
                 <dd v-if="orderDetail.shippingResultVo">
                  {{orderDetail.shippingResultVo.time}}
                </dd>
                 <dd v-else>{{orderDetail.createAtString}}</dd>
               </dl>
              
          </div>
        </div>
        <div class="user_info">
          <div class="info_hd">
            <p class="title">收货信息</p>
            <p v-if="orderDetail.shippingStatus == 0 && orderDetail.welfareType == 2" class="btn-edit">
              <router-link :to="{ path: '/address', query:{ orderId:orderDetail.orderId } }">编辑</router-link>
            </p>
          </div>
          <ul>
            <li>
              <p class="name">收货人</p>
              <p class="val">{{orderDetail.consignee}}</p>
            </li>
            <li>
              <p class="name">手机号</p>
              <p class="val">{{orderDetail.mobile}}</p>
            </li>
            <li>
              <p class="name">收货地址</p>
              <p class="val adress">{{orderDetail.province + ' ' + orderDetail.city +' ' + orderDetail.district}}<br/>{{orderDetail.address}}</p>
            </li>
          </ul>
        </div>
        <div class="order_info">
          <p class="title">订单信息</p>
          <ul>
            <li>
              <p class="name">订单编号</p>
              <p class="val">{{orderDetail.orderSn}}</p>
            </li>
            <li>
              <p class="name">领取时间</p>
              <p class="val">{{orderDetail.createAtString}}</p>
            </li>
          </ul>
        </div>
      </div>
      <home :ishome=0></home>
  </div>
</template>
<script>
import {
    mapGetters,
    mapActions
} from 'vuex'
import home from '../common/home.vue'
import Clipboard from "clipboard"
export default {
  data () {
    return {
      loading: true,
      toastMsg: "复制成功",
      copyState: false,
      cdkeyText: '待提取',
      times: 10,
      getcdkeyDis: false
    }
  },
  components:{
  home

  },
  computed:{   	 	 
  	 ...mapGetters({
       'orderDetail':'getorderDetail',
       getUserInfo: 'getUserInfo',
    }),
    corpId(){
      return this.getUserInfo.corpId || '';
    },
     orderId(){
       let id='';
       if(this.$route.query.orderId){
        id=this.$route.query.orderId
       }
       return id;
     },
     statusText(){
        let text=''
        
          switch(this.orderDetail.shippingStatus){
            case 0:
              text="待发货"
              break;
            case 1:
              text="已发货"
              break;

          }
        return text;
     },
  },
  watch:{
    orderDetail(cval){
      if(cval){
        this.loading=false;
      }
    },
    
  },
  beforeDestroy() {
    // 组件销毁时恢复默认标题
    this.$store.commit('CORP_CUSTOMIZE_ATTR', {
      data: {
        key: 'page_title_default',
        value: ''
      }
    })
  },
  created(){
    let _this = this
    
    this.$store.dispatch('loadOrderDetail',{orderId:this.orderId })
    var clipboard = new Clipboard(".button");
    clipboard.on("success", function(e) {
      _this.copyState = true;
      setTimeout(function() {
        _this.copyState = false;
      }, 800);
    });
   
  },
  methods:{
    focus(event) {
    event.currentTarget.select();
    },
    goExpress(data){
        if(data.welfareType==2){
          this.$router.push({
            name:'orderTrack',
            query:{
              orderId:data.orderId,
              type:1
            }
          })
        }else{
          this.$router.push({
            name:'orderTrack',
            query:{
              orderId:data.orderId,
              type:4
            }
          })
        }
        
      },
      goToWelfareDetail(data){
        this.$router.push({
            name:'welfareDetail',
            query:{
              goodsId:data.goodsId,
              orderGoodsVoucherId:data.orderGoodsVoucherId ,
              goodsVoucherId:data.goodsVoucherId,
              welfareType:data.welfareType
            }
          })
      },
      getcdkey() {
        let that = this;
        that.times = 10
        that.getcdkeyDis = true
        clearInterval()
        let _timer = setInterval(()=> {
          if(that.orderDetail&&(!that.orderDetail.goodsContent||that.orderDetail.goodsContent=='')&& that.times>=0) {
            that.cdkeyText = '卡密提取中(' + that.times + ')'
            that.$store.dispatch('loadOrderDetail',{orderId:that.orderId })
            that.times--
          } else {
            clearInterval(_timer)
            that.cdkeyText = '提取失败，请重试'
            that.getcdkeyDis = false
          }
        },1000)
      }
  },
  filters: {  
    longText(val) {
        if (val) {
            if (val.length > 32) {
                return val.substr(0, 32) + "...";
            } else {
                
                return val;
            }
        } else {
            return "";
        }
    }
  },
  mounted(){
    this.$store.commit('CORP_CUSTOMIZE_ATTR', { 
        data: { 
          key: 'page_title_default', 
          value: '订单详情',
        } 
    })
  }
}
</script>